/**
 * @description 是否字母数字格式
 * @param {String} string
 * @returns {Boolean}
 */
export const formatLetNum = (string: string): boolean => /^[a-zA-Z0-9]+$/.test(String(string))
